module.exports = {
  CROATIA: {
    id: 1,
    value: 'CROATIA',
    label: { HR: 'Hrvatska' }
  }
};
